import React from "react";
import styles from "./SectionHeader.module.scss";

function SectionHeader(props) {
  // Render nothing if no title or subtitle
  if (!props.title && !props.subtitle) {
    return null;
  }

  return (
    <header
      className={
        styles.SectionHeader + (props.className ? ` ${props.className}` : "")
      }
    >
      {/* {props.anchortext && (
        <a name={props.anchortext}></a>
      )} */}
      {props.title && (
        <h1
          className={
            "font-weight-bold" +
            (props.subtitle && props.spaced ? " mb-4" : "") +
            (!props.subtitle ? " mb-0" : "") +
            (props.size ? ` h${props.size}` : "")
          }
        >
          {props.title}
        </h1>
      )}

      {props.title2 && (
        <h1
          className={
            "font-weight-bold" +
            (props.spaced ? " mt-2" : "") +
            (props.subtitle && props.spaced ? " mb-4" : "") +
            (!props.subtitle ? " mb-0" : "") +
            (props.size ? ` h${props.size}` : "")
          }
        >
          {props.title2}
        </h1>
      )}

      {props.subtitle && (
        <p className="SectionHeader__subtitle mb-0">{props.subtitle}</p>
      )}
      {props.subtitle2 && (
        <>
          <br />
          <p className="SectionHeader__subtitle mb-0">{props.subtitle2}</p>
        </>
      )}
    </header>
  );
}

export default SectionHeader;
